__turbopack_context__.v({
  "content": "ktrb7q_content",
  "footer": "ktrb7q_footer",
  "footer-content": "ktrb7q_footer-content",
  "img": "ktrb7q_img",
  "imgResponsive": "ktrb7q_imgResponsive",
  "language-selector-wrapper": "ktrb7q_language-selector-wrapper",
  "light": "ktrb7q_light",
  "root": "ktrb7q_root",
});
